var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast-slide-up","mode":"out-in"}},[(_vm.open)?_c('div',{staticClass:"toast"},[_c('div',[_vm._v(_vm._s(_vm.title))]),(_vm.showTimer)?_c('div',{staticClass:"regret",on:{"click":_vm.cancelToast}},[_vm._v(" "+_vm._s(_vm.$t('toast_regret'))+" ("+_vm._s(_vm.timer)+") ")]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }